import { render, staticRenderFns } from "./Exports.vue?vue&type=template&id=08103964&scoped=true"
import script from "./Exports.vue?vue&type=script&lang=js"
export * from "./Exports.vue?vue&type=script&lang=js"
import style0 from "./Exports.vue?vue&type=style&index=0&id=08103964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08103964",
  null
  
)

export default component.exports